import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Tasks: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2.05234 21.0354H15.3715C15.9523 21.0354 16.4238 20.5466 16.4238 19.9446V14.0484C16.4238 13.4464 15.9523 12.9577 15.3715 12.9577H2.05234C1.47157 12.9577 1.0001 13.4464 1.0001 14.0484V19.9446C1.00213 20.5467 1.47362 21.0354 2.05234 21.0354ZM2.14542 14.1446H15.2724L15.2744 19.8416H2.14537L2.14542 14.1446ZM22.4215 6.2508H16.4174V3.89934C16.4174 3.29731 15.9459 2.80859 15.3652 2.80859H2.05223C1.47146 2.80859 1 3.29735 1 3.89934V9.79557C1 10.3976 1.47149 10.8863 2.05223 10.8863H15.3714C15.9522 10.8863 16.4237 10.3976 16.4237 9.79557V7.43783H21.8527V16.4008H19.7967L20.8166 15.3436C21.0392 15.1129 21.0392 14.7374 20.8166 14.5066C20.594 14.2759 20.2318 14.2759 20.0092 14.5066L18.0099 16.5791C17.7873 16.8099 17.7873 17.1853 18.0099 17.4161L20.0092 19.4886C20.1225 19.606 20.2682 19.6606 20.4139 19.6606C20.5596 19.6606 20.7093 19.6018 20.8186 19.4886C21.0412 19.2578 21.0412 18.8824 20.8186 18.6516L19.7987 17.5944H22.4253C22.741 17.5944 23 17.3322 23 16.9986L22.996 6.84616C22.9919 6.51893 22.7372 6.2508 22.4215 6.2508ZM15.2741 9.69305H2.14506V3.99605H15.2721L15.2741 9.69305Z'
        fill='url(#paint0_linear_12280_31583)'
        stroke='url(#paint1_linear_12280_31583)'
        strokeWidth='0.5'
      />
      <defs>
        <linearGradient
          id='paint0_linear_12280_31583'
          x1='5.55569'
          y1='4.05146'
          x2='12.896'
          y2='21.8092'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_31583'
          x1='5.55569'
          y1='4.05146'
          x2='12.896'
          y2='21.8092'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Tasks;
